import { DeepPartial } from '@reduxjs/toolkit';
import { IPagination, IPaginationDTO } from './pagination.model';

export enum RegionsEndpoints {
  REGIONS = '/regions',
  REGIONS_AUTOCOMPLETE = '/regions/autocomplete',
  SETTLEMENTS = '/settlements',
  SETTLEMENTS_AUTOCOMPLETE = '/settlements/autocomplete',
  DELIVERY_WAREHOUSES = '/delivery-warehouses',
}

export interface IPickupLocale {
  uk: {
    id: string;
    name: string;
    working_hours: string;
    address: string;
  };
  ru: {
    id: string;
    name: string;
    working_hours: string;
    address: string;
  };
}

export interface IPickupRegion {
  id: string;
  name: string;
}

export interface ISettlement {
  id: string;
  name: string;
  region: IPickupRegion;
  region_id: string;
  latitude?: string;
  longitude?: string;
}

export interface IPickup {
  id: string;
  phone: string;
  external_id: string;
  latitude: number;
  longitude: number;
  is_default: boolean;
  is_active: boolean;
  google_store_code: string | null;
  locale: IPickupLocale;
  settlement: ISettlement;
}

export interface IRegion {
  id: string;
  name: null | string;
  main_settlement: string;
  active: boolean;
}

export interface ISettlementLocale {
  uk: {
    title: string;
    name: string;
  };
  ru: {
    title: string;
    name: string;
  };
}

export interface IRegionSettlement {
  id: string;
  name: null | string;
  region_id: string;
  center: boolean;
  in_header: boolean;
  active: boolean;
  locale: ISettlementLocale;
}

// ----------------- DTOs ----------------

export interface IGetRegionsDTO extends Partial<IPaginationDTO> {
  title?: string;
  slug?: string;
  is_active?: boolean;
}

export interface IGetPickupDTO extends Partial<IPaginationDTO> {
  region_id?: string;
  settlement_id?: string;
  address?: string;
  is_default?: string;
  phone?: string;
  is_active?: string;
}

export interface ICreatePickupDTO {
  latitude?: number;
  longitude?: number;
  phone?: string;
  external_id: string;
  settlement_id: string;
  is_default: string;
  is_active: string;
  google_store_code?: string | null;
  locale: DeepPartial<IPickupLocale>;
}

export interface IEditPickupDTO extends Partial<ICreatePickupDTO> {
  id: string;
}

export interface IGetRegionSettlementsDTO extends Partial<IPaginationDTO> {
  region_id: string;
}

export interface IAutocompleteRegionsDTO extends Partial<IPaginationDTO> {
  search: string;
  limit?: number;
}

export interface IAutocompleteSettlementsDTO extends Partial<IPaginationDTO> {
  search: string;
  region_id?: string;
  limit?: number;
  with_region?: '1' | '0';
  with_pickup?: '1' | '0';
}

// ------------ Responses --------------

export interface IAutocompleteRegionsResponse {
  data: IRegion[];
}

export interface IAutocompleteSettlementsResponse {
  data: ISettlement[];
}

export interface IGetRegionsResponse {
  data: IRegion[];
  meta: IPagination;
}

export interface IGetPickupsResponse {
  data: IPickup[];
  meta: IPagination;
}

export interface IGetRegionSettlementsResponse {
  data: IRegionSettlement[];
  meta: IPagination;
}

export interface IGetPickupResponse {
  data: IPickup;
}
